import script from "./GameTask.vue?vue&type=script&setup=true&lang=js"
export * from "./GameTask.vue?vue&type=script&setup=true&lang=js"

import "./GameTask.vue?vue&type=style&index=0&id=6f1388fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1388fc"]])

export default __exports__